module.exports = __webpack_public_path__ + "static/media/Amir Hosein Khasahmadi.5fe7e704.png";